import { render } from "./ColumnChartPfand.vue?vue&type=template&id=4bba0381&scoped=true"
import script from "./ColumnChartPfand.vue?vue&type=script&lang=js"
export * from "./ColumnChartPfand.vue?vue&type=script&lang=js"

import "./ColumnChartPfand.vue?vue&type=style&index=0&id=4bba0381&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bba0381"]])

export default __exports__